import { openBlock as n, createElementBlock as o, createElementVNode as t, defineComponent as b, mergeModels as p, useModel as B, computed as d, createBlock as l, Transition as C, withCtx as w, mergeProps as m, unref as r, normalizeProps as I, createCommentVNode as i, renderSlot as y, toDisplayString as V, Fragment as z, renderList as L } from "vue";
import { I as x } from "../../chunks/close.4a2156a0.js";
import { AdsButton as A } from "../../atoms/button/index.js";
import { AdsIcon as P } from "../../atoms/icon/index.js";
import { AdsLink as S } from "../../atoms/link/index.js";
import { _ as E } from "../../chunks/index.99cfd0be.js";
import { u as D } from "../../chunks/useIconProps.ee768c90.js";
import { useI18n as F } from "vue-i18n";
import './index.css';const H = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "ads-icon-danger",
  viewBox: "0 0 24 24"
};
function N(e, s) {
  return n(), o("svg", H, s[0] || (s[0] = [
    t("path", { d: "M21.74 18.05 13.77 4.02c-.77-1.36-2.77-1.36-3.55 0L2.26 18.05C1.51 19.37 2.49 21 4.03 21h15.94c1.55 0 2.52-1.63 1.77-2.95M11.24 8c0-.41.34-.74.76-.74s.76.33.76.74v5.8c0 .41-.34.74-.76.74a.75.75 0 0 1-.76-.74zm.76 9.77a.997.997 0 0 1-1.01-.99c0-.55.45-.99 1.01-.99s1.01.44 1.01.99-.45.99-1.01.99" }, null, -1)
  ]));
}
const O = { render: N }, j = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "ads-icon-info",
  viewBox: "0 0 24 24"
};
function q(e, s) {
  return n(), o("svg", j, s[0] || (s[0] = [
    t("path", { d: "M12 3a9 9 0 1 0 .001 18.001A9 9 0 0 0 12 3m.75 14c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-6c0-.41.34-.75.75-.75s.75.34.75.75zM12 8c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1" }, null, -1)
  ]));
}
const g = { render: q }, T = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "ads-icon-success",
  viewBox: "0 0 24 24"
};
function W(e, s) {
  return n(), o("svg", T, s[0] || (s[0] = [
    t("path", {
      "fill-rule": "evenodd",
      d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m4.576-11.52a.75.75 0 0 0-1.152-.96l-4.474 5.369-2.42-2.42a.75.75 0 0 0-1.06 1.061l3 3a.75.75 0 0 0 1.106-.05z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const Z = { render: W }, G = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "ads-icon-warning",
  viewBox: "0 0 24 24"
};
function J(e, s) {
  return n(), o("svg", G, s[0] || (s[0] = [
    t("path", {
      "fill-rule": "evenodd",
      d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0m-9-5.75a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-1.5 0V7a.75.75 0 0 1 .75-.75M12 18a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const K = { render: J }, Q = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "24",
  fill: "none"
};
function R(e, s) {
  return n(), o("svg", Q, s[0] || (s[0] = [
    t("g", {
      fill: "#1E1852",
      "clip-path": "url(#a)"
    }, [
      t("path", { d: "M22.472 23.99h-5.55l-4.082-8.794c-1.25.674-2.199 1.844-3.19 3.065-.775.956-1.576 1.943-2.567 2.75-1.154.938-2.495 1.768-4.17 2.335-.76.254-2.051.586-2.534.635-.207.02-.345.01-.375-.058-.02-.059.03-.098.246-.206.044-.02.113-.05.199-.09.398-.177 1.178-.525 1.704-.887.799-.557 1.252-1.153 1.292-1.612-.04-.142-.127-.315-.232-.524-.458-.918-1.256-2.517.044-5.056.23-.452.447-.851.648-1.22.298-.55.56-1.031.772-1.516.404-.929.7-2.238.799-3.216.01-.058.02-.058.049-.02.779.783 3.796 3.851 3.352 6.91 1.006-.381 2.74-1.544 3.54-2.16q.279-.219.526-.43c.582-.49 1.072-.903 1.77-.918.45-.006.668.112.887.23.17.093.341.185.622.22.158.019.394-.01.512-.07.05-.019.04-.077-.039-.097-.36-.085-.61-.257-.857-.428-.348-.24-.695-.48-1.351-.48-.757 0-1.402.52-1.923.939-.171.138-.329.266-.473.36l-2.85-5.883C8.06 5.306 8.415 3.518 11.037 0zm9.06.01h-3.44c-1.45 0-2.19-.318-2.722-1.023-.571-.744-.571-1.886-.571-2.959V.01h4.436v20.654c0 1.638.178 2.8 2.297 3.266zm5.028 0H40v-.07c-2.12-.466-2.297-1.628-2.297-3.266V.01h-4.437v20.008c0 1.073 0 2.215.572 2.96.533.704 1.272 1.022 2.721 1.022Z" })
    ], -1),
    t("defs", null, [
      t("clipPath", { id: "a" }, [
        t("path", {
          fill: "#fff",
          d: "M0 0h40v24H0z"
        })
      ])
    ], -1)
  ]));
}
const U = { render: R }, X = { class: "ads-message__wrapper" }, Y = {
  key: 0,
  class: "ads-message__icon-container"
}, ee = {
  key: 1,
  class: "ads-message__content"
}, se = {
  key: 0,
  class: "ads-message__message"
}, ne = {
  key: 1,
  class: "ads-message__links"
}, ue = /* @__PURE__ */ b({
  name: "AdsMessage",
  __name: "index",
  props: /* @__PURE__ */ p({
    icon: { type: [String, Function, Object] },
    message: {},
    links: {},
    variation: { default: "default" },
    border: { type: Boolean },
    closable: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "div" }
  }, {
    isVisible: { type: Boolean, default: !0 },
    isVisibleModifiers: {}
  }),
  emits: /* @__PURE__ */ p(["close"], ["update:isVisible"]),
  setup(e) {
    const s = B(e, "isVisible"), { t: $ } = F(), v = d(() => e.variation === "loyalty"), k = d(() => ["ads-message", `ads-message--${e.variation}`, { "ads-message--border": e.border }]), _ = d(() => {
      const a = e.variation === "danger" || e.variation === "warning" || e.variation === "success";
      return e.icon && !a ? e.icon : {
        default: g,
        neutral: g,
        accent: g,
        success: Z,
        warning: K,
        danger: O,
        loyalty: void 0
      }[e.variation];
    }), { iconProps: c } = D(_), f = d(() => e.links && e.links.length > 0);
    return (a, u) => (n(), l(C, { name: "fade-slide-vertical" }, {
      default: w(() => [
        s.value ? (n(), l(E, m({ key: 0 }, { as: a.as, asChild: a.asChild }, { class: k.value }), {
          default: w(() => [
            t("div", X, [
              r(c) || v.value ? (n(), o("div", Y, [
                v.value ? (n(), l(r(U), { key: 0 })) : r(c) ? (n(), l(P, I(m({ key: 1 }, r(c))), null, 16)) : i("", !0)
              ])) : i("", !0),
              a.message || a.$slots.title || a.$slots.default || f.value ? (n(), o("div", ee, [
                y(a.$slots, "title"),
                a.message || a.$slots.default ? (n(), o("div", se, [
                  y(a.$slots, "default", {}, () => [
                    t("p", null, V(a.message), 1)
                  ])
                ])) : i("", !0),
                f.value ? (n(), o("div", ne, [
                  (n(!0), o(z, null, L(a.links, (h, M) => (n(), l(S, m({
                    key: M,
                    ref_for: !0
                  }, h), null, 16))), 128))
                ])) : i("", !0)
              ])) : i("", !0),
              a.closable ? (n(), l(A, {
                key: 2,
                class: "ads-message__close-button",
                variation: "none",
                "aria-label": r($)("ads.modal.closeLabel"),
                "icon-only": "",
                "prepend-icon": { component: r(x), size: 24 },
                onClick: u[0] || (u[0] = (h) => a.$emit("close", !0))
              }, null, 8, ["aria-label", "prepend-icon"])) : i("", !0)
            ])
          ]),
          _: 3
        }, 16, ["class"])) : i("", !0)
      ]),
      _: 3
    }));
  }
});
export {
  ue as AdsMessage
};
